export default __webpack_public_path__ + "static/media/uob-color.0de532c8.svg";